var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneReadOnly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "texteditor/phonenumber"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2019 10.5606L11.1761 8.99259C11.0782 8.91709 10.9562 8.87984 10.8329 8.8878C10.7096 8.89577 10.5934 8.9484 10.5061 9.03586L9.4308 10.1116C9.35071 10.1925 9.24566 10.244 9.13266 10.2577C9.01966 10.2715 8.90532 10.2467 8.80815 10.1874C8.46195 9.97513 7.88257 9.56378 7.15758 8.83833C6.43259 8.1139 6.02122 7.53405 5.80892 7.18838C5.74954 7.09129 5.72476 6.97697 5.73863 6.86401C5.7525 6.75105 5.80419 6.64611 5.88529 6.56627L6.96055 5.49057C7.04813 5.40331 7.10082 5.28706 7.10869 5.16368C7.11657 5.0403 7.07909 4.9183 7.00332 4.82061L5.43573 2.79444C5.07935 2.33473 4.40731 2.26193 3.96947 2.64629C3.39264 3.15233 2.69972 3.91036 2.49811 4.76105C2.13307 6.2934 2.70991 8.21623 5.24532 10.7515C7.78074 13.2862 9.70369 13.8635 11.2356 13.499C12.0864 13.2964 12.845 12.603 13.351 12.0268C13.7349 11.5889 13.6621 10.9169 13.2019 10.5606Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneReadOnly);
export default __webpack_public_path__ + "static/media/phoneReadOnly.4c91b978fd3158a9e799828136d1daa4.svg";
export { ForwardRef as ReactComponent };